import React from "react";
import { Col } from "antd";
import { ReactComponent as TreezLogo } from "../../assets/treez-logo.svg";

const Header: React.FC = () => (
  <Col span={24}>
    <TreezLogo className="treez-logo" width={70} height={23} />
    <div className="divider" />
  </Col>
);

export default Header;
